import React, { useEffect, useRef } from "react"
import { makeStyles, InputLabel, TextField } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    label: {
        marginBottom: '12px'
    }
}));

export default function InputText(props) {
    const classes = useStyles();
    const textInputRef = useRef(null);

    useEffect(()=>{
        if(props.selectAllText && textInputRef.current) {
            let inputRef = (textInputRef.current.querySelectorAll('input')[0])
            const startIndex = 0;
            const endIndex = inputRef.value.length;
            inputRef.setSelectionRange(startIndex, endIndex);
            inputRef.focus();
        }
    },[props.selectAllText, textInputRef.current])

    useEffect(()=>{
      let inputRef = (textInputRef.current.querySelectorAll('input')[0])
      if(props.autofocus) {
        inputRef.focus()
      }
    },[])

    return (
        <>
            {props.label ? <InputLabel htmlFor={props.id} className={classes.label}>{props.label}</InputLabel> : null}
            <div ref={textInputRef}>
                <TextField
                    type="text"
                    fullWidth
                    id={props.id}
                    value={props.value}
                    onChange={(e) => { props.onChange(e.target.value) }}
                    variant="outlined"
                    disabled={props.disabled}
                    error={props.hasError}
                    helperText={props.errorText}
                    autoFocus={props.autoFocus}
                />
            </div>
        </>
    )
}